import $ from 'jquery';
import Util from 'root/module/util';

import jui from 'root/lib/jquery-ui.min';

export default {
    _overlay: null,
    _element: null,

    _onclose: null,

    open: function(options) {
        if (this._element) {
            this._forceClose(true);
        }

        $(document.body).addClass('modal-open');

        if (!this._overlay) {
            this._overlay = $('<div>').addClass('overlay overlay-bottombar');

            this._overlay.appendTo($(document.body));

            $(document).on('keyup', $.proxy(this._documentKeyup, this));
        }

        this._element = $('<div>').addClass('bottombar');

        // close button
        $('<button>')
            .attr('type', 'button')
            .addClass('bottombar-close btn-close')
            .html('<i class="fa-regular fa-xmark"></i>')
            .on('click', this.close.bind(this))
            .appendTo(this._element);

        var body = $('<div>').addClass('bottombar-body').appendTo(this._element);

        if (options.classname) {
            body.addClass(options.classname);
        }

        if (options.draggable) {
            body.html('<span class="drag-handle"></span>');

            this._element.find('.drag-handle').draggable({
                axis: 'y',
                helper: 'clone',
                start: (e, ui) => {
                    ui.helper.data('panel_height', this._element.height());
                    ui.helper.data('offset_top_start', ui.offset.top);
                },
                drag: (e, ui) => {
                    var movement_y = ui.offset.top - ui.helper.data('offset_top_start');
                    var height = ui.helper.data('panel_height') + movement_y * -1;

                    this._element.height(height);
                }
            });
        }

        // content
        if (typeof options.content === 'string') {
            $('<div>').addClass('bottombar-content').html(options.content || '').appendTo(body);
        } else {
            $('<div>').addClass('bottombar-content').html(options.content.render().$el).appendTo(body);
        }

        if (options.onclose) {
            this._onclose = options.onclose;
        }

        if (options.onopen) {
            Util.animationEnd(this._element, options.onopen);
        }

        this._element.appendTo(this._overlay);

        return this._element;
    },

    close: function() {
        if (!this._element) {
            return;
        }

        $(document.body).removeClass('modal-open');

        $(document).off('keyup', $.proxy(this._documentKeyup, this));

        if (this._onclose) {
            this._onclose(this._modal);
        }

        this._forceClose();
    },

    _documentKeyup: function(e) {
        if (e.which === 27) {
            this.close();
        }
    },

    _forceClose: function(skip_overlay) {
        if (this._element) {
            this._element.remove();
            this._element = null;
        }

        if (skip_overlay !== true && this._overlay) {
            this._overlay.remove();
            this._overlay = null;
        }
    }
};